define([
    './directives/PAQuickQuoteEditState',
    './directives/PAQuickQuoteQuotingState',
    './directives/PAQuickQuoteQuotedState',
    './directives/PAQuickQuoteQuoteErrorState',
    './directives/PAQuickQuoteTile'
], (PAQuickQuoteEditState,
    PAQuickQuoteQuotingState,
    PAQuickQuoteQuotedState,
    PAQuickQuoteQuoteErrorState,
    PAQuickQuoteTile) => {
    angular.module('edge.quoteandbind.quickquote.pa.tiles.quote', [])
        .directive('gwPaQuickQuoteEditState', PAQuickQuoteEditState)
        .directive('gwPaQuickQuoteQuotingState', PAQuickQuoteQuotingState)
        .directive('gwPaQuickQuoteQuotedState', PAQuickQuoteQuotedState)
        .directive('gwPaQuickQuoteQuoteErrorState', PAQuickQuoteQuoteErrorState)
        .directive('gwPaQuickQuoteTile', PAQuickQuoteTile);
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/quote/app.js
 **/